import { useLocation, Outlet } from "react-router-dom";
import {
  Shield, ListTodo, UserPlus, Settings
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = [
  {
    id: "vetting-dashboard",
    label: "Vetting Cases",
    icon: ListTodo,
    path: "/vetting",
    description: "View and manage vetting cases"
  },
  {
    id: "vetting-new",
    label: "New Case",
    icon: UserPlus,
    path: "/vetting/new",
    description: "Create a new vetting case"
  },
  {
    id: "vetting-admin",
    label: "Admin",
    icon: Settings,
    path: "/vetting/admin",
    description: "Classification criteria & audit"
  }
];

export default function SmartVettingLayout() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="SMART VETTING"
        subtitle="Intelligent Vetting Operations"
        icon={Shield}
        gradient="from-indigo-500 to-purple-600"
        activeBg="bg-indigo-500"
      />

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
